import { Seo, Reveal } from "../components/Seo";
import { PageHero, CtaBand } from "../components/blocks";
import { INDUSTRIES } from "../lib/site";

export default function Industries() {
  return (
    <>
      <Seo
        title="Industries — Softline Nigeria"
        description="Government, financial services, enterprise, healthcare, education and technology platforms — sectors Softline Nigeria builds for."
        path="/industries"
      />
      <PageHero
        eyebrow="Industries"
        title={["Solutions designed around", "real operational needs."]}
        lead="Sector relevance, stated honestly: these are the operating contexts our products and services are designed for — not a list of customer claims."
        crumbs={[{ label: "Home", to: "/" }, { label: "Industries" }]}
      />

      <section className="bg-white" data-testid="industries-list">
        <div className="shell py-24 md:py-32 space-y-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} delay={i * 0.04}>
              <article
                data-testid={`industries-item-${i}`}
                className="grid lg:grid-cols-12 gap-6 border border-charcoal/10 p-8 md:p-10 hover:border-charcoal/30 transition-[border-color] duration-200"
              >
                <div className="lg:col-span-5">
                  <span className="font-mono text-xs text-charcoal/45">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="font-display font-bold text-2xl md:text-3xl mt-3">{ind.name}</h2>
                  <p className="mt-4 text-charcoal/70 leading-relaxed">{ind.desc}</p>
                </div>
                <div className="lg:col-span-7 lg:pl-10 lg:border-l border-charcoal/10">
                  <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-charcoal/55">Relevant use cases</p>
                  <ul className="mt-5 grid sm:grid-cols-1 gap-3">
                    {ind.useCases.map((u) => (
                      <li key={u} className="flex items-start gap-3 text-[15px] text-charcoal/75">
                        <span className="h-2 w-2 bg-lime mt-1.5 shrink-0" aria-hidden="true"></span>
                        {u}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.1}>
            <p className="text-sm text-charcoal/55 max-w-3xl" data-testid="industries-note">
              Use cases describe potential applications of Softline products and services. Customer names, logos and case
              studies are published only with verified, written approval.
            </p>
          </Reveal>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
